export default "__VITE_ASSET__f694f857__"